import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditPersonalPage = {
  alert: {
    error: 'coapplicant-edit-personal-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-personal-page.footer.root',
  },
  form: {
    cancelButton: 'coapplicant-edit-personal-page.form.cancel-button',
    emailAddressInput:
      'coapplicant-edit-personal-page.form.email-address-input',
    emailAddressInputError:
      'coapplicant-edit-personal-page.form.email-address-input-error',
    firstNameInput: 'coapplicant-edit-personal-page.form.first-name-input',
    firstNameInputError:
      'coapplicant-edit-personal-page.form.first-name-input-error',
    h1: 'coapplicant-edit-personal-page.form.h1',
    h2: 'coapplicant-edit-personal-page.form.h2',
    lastNameInput: 'coapplicant-edit-personal-page.form.last-name-input',
    lastNameInputError:
      'coapplicant-edit-personal-page.form.last-name-input-error',
    phoneInput: 'coapplicant-edit-personal-page.form.phone-input',
    phoneInputError: 'coapplicant-edit-personal-page.form.phone-input-error',
    root: 'coapplicant-edit-personal-page.form.root',
    submitButton: 'coapplicant-edit-personal-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
